var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZaranear2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7.14 19.49",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05,19.1c.15.04.12.38-.07.37-.56-.03-1.18.05-1.73,0-.15-.01-.22-.04-.23-.21-.06-.54.05-1.2,0-1.76.04-.23.38-.16.38-.06v1.6l.05.05h1.6Z",
    fill: "#1d1d1b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91,12.94c-.15-.04-.12-.38.06-.37.56.04,1.22-.07,1.76,0,.16.02.19.08.21.24.05.55-.04,1.17,0,1.73-.04.23-.38.16-.38.06v-1.6l-.05-.05h-1.6Z",
    fill: "#1d1d1b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.4,14.59c-.04.14-.34.13-.38-.06.04-.56-.05-1.18,0-1.73.01-.15.04-.22.21-.23.54-.06,1.2.05,1.76,0,.25.04.16.37.07.37H.44l-.05.05v1.6Z",
    fill: "#1d1d1b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56,17.45c.04-.14.34-.13.38.06-.04.56.05,1.18,0,1.73-.01.15-.04.22-.21.23-.54.06-1.2-.05-1.76,0-.25-.04-.16-.37-.07-.37h1.6l.05-.05v-1.6Z",
    fill: "#1d1d1b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m5.93 15.98c0-1.34-1.07-2.43-2.41-2.43s-2.43 1.07-2.43 2.41 1.07 2.43 2.41 2.43 2.43-1.07 2.44-2.41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83,14.74c0-.17-.14-.32-.32-.32-.17,0-.32.14-.32.32,0,.18.14.32.32.32.17,0,.32-.14.32-.32",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26,17.32s.17-.89.25-.89c.08,0,.23.89.23.89.02.1.07.18.18.18.13,0,.2-.09.18-.18h0s0-.01,0-.01l-.18-1-.03-.25s-.02-.16,0-.22c0-.02.02-.04.08-.06l.54-.16h0c.09-.04.18-.08.18-.18,0-.1-.07-.21-.18-.18-.02,0-.03,0-.05.01-.15.04-.61.16-.95.16-.36,0-.87-.15-.98-.18,0,0-.01,0-.02,0h0s0,0,0,0c-.11-.03-.18.08-.18.18,0,.1.09.15.18.18,0,0,0,0,0,0l.5.18c.07.03.09.05.1.06,0,.01.02.06,0,.21l-.03.25-.19.99s0,.02,0,.02c-.01.09.05.18.18.18.11,0,.16-.08.18-.18",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.05,
    width: 7.09,
    height: 10.63,
    fill: "#1d1e1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.23,
    y: 1.18,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.23,
    y: 4.73,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.23,
    y: 5.91,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.23,
    y: 8.27,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.41,
    y: 1.18,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2.41,
    y: 3.54,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2.41,
    y: 5.91,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 3.59,
    y: 2.36,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 3.59,
    y: 3.54,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3.59,
    y: 8.27,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 4.77,
    y: 1.18,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 4.77,
    y: 4.73,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 4.77,
    y: 8.27,
    width: 1.18,
    height: 1.18,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZaranear2);
export default __webpack_public_path__ + "static/media/zaranear2.4b8fefbbbd92cab7fd45fa942f19bfea.svg";
export { ForwardRef as ReactComponent };